let $doc = $(document);
let $win = $(window);

let scrollTop = 0;

function updateFields($this, $form){
  if ($this.hasClass('js-hide-reuqired')) {
    $form.find('[data-required="true"]').removeClass('form__row--required')
    $form.find('[data-hide="true"]').addClass('js-hide');
  } else {
    $form.find('[data-required="true"]').addClass('form__row--required');
    $form.find('[data-hide="true"]').removeClass('js-hide');
  }
}

$win.on('scroll resize orientationchange', function() {
  scrollTop = $win.scrollTop();
});

$doc.ready(function() {
  updateFields($('#contact_form input[name="contact[inquiry]"]'), $('#contact_form'));

  $(".checkbox-radio input").on('change', function() {
    const $this = $(this);
    const $form = $(this).closest('form');
    $form.find(".checkbox-radio input").prop('checked', false);
    $this.prop('checked', true);
    updateFields($this, $form);
  });
})

$doc
  .on('change', '.product--single .product__quantity input', function() {
    quantityCheck();
  })
  .on('click', '.quantity-controls .btn', function() {
    quantityUpdate($(this));
    quantityCheck();
    ajaxUpdateToCart();
  })
  .on('change', '.swatch__element input', function() {
    swatchToggle($(this));
    quantityCheck();
  })
  .on('submit', 'form[action="/cart/add"]', function(e) {
    e.preventDefault();
    ajaxAddToCart($(this));

    let $popup = $(this).find('.form__popup');

    $popup.toggleClass('popup-bottom', $popup.offset().top - scrollTop < 300);
  })
  .on('click', '.close-popup', function(e) {
    e.preventDefault();
    $('.form__popup-success').removeClass('popup-expanded');
  });

function quantityCheck() {
  let $input = $('.swatch__element input:checked');
  let id = $input.data('id');
  let quantity = Number($input.data('quantity'));
  let val = Number($('#product-quantity').val());

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(response) {
      let items = response.items;
      let $btnSubmit = $('form[action="/cart/add"]').find('.btn-submit');
      let $btnLimited = $('form[action="/cart/add"]').find('.btn-limited');
      let $btnSoldOut = $('form[action="/cart/add"]').find('.btn-sold-out');
      let flag = false;

      $('.form__popup-error').removeClass('popup-expanded');

      for (var i = 0; i < items.length; i++) {
        if (items[i].id == id && Number(items[i].quantity) + val > quantity && quantity > 0) {
          $('.form__popup-error .product-quantity').text(quantity);
          $btnLimited.removeClass('hide');
          $btnSubmit.addClass('hide');
          $btnSoldOut.addClass('hide');
          $('.form__popup-error').addClass('popup-expanded');

          flag = true;
        }
      }

      if (!flag && val > quantity && quantity > 0) {
        $('.form__popup-error .product-quantity').text(quantity);
        $btnLimited.removeClass('hide');
        $btnSubmit.addClass('hide');
        $btnSoldOut.addClass('hide');
        $('.form__popup-error').addClass('popup-expanded');
      } else if (!flag && val <= quantity && quantity > 0) {
        $btnLimited.addClass('hide');
        $btnSubmit.removeClass('hide');
      }

      setTimeout(function() {
        $('.form__popup-error').removeClass('popup-expanded');
      }, 5000);
    },
    error: function(data) {
      console.log('error');
    }
  });
}

function ajaxCartUpdate($serializeForm) {
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    data: $serializeForm,
    success: function(data) {
      updateCount(data);
      updateCartWrapper(data, false);
    },
    error: function(data) {
      console.log('error: ' + data);
    }
  });
}

var ajaxUpdateToCart = function() {
  let $serializeForm = $('form[action="/cart"]').serialize();

  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    data: $serializeForm
  });
};

var ajaxAddToCart = function($form) {
  var serializeForm = $form.serialize();

  $.ajax({
    type: 'POST',
    url: '/cart/add',
    // dataType: 'html',
    data: serializeForm,
    success: function(response) {
      $('.form__popup-success').addClass('popup-expanded');
      $('body').removeClass('loading');
    },
    error: function(data) {
      $('.form__popup-success').removeClass('popup-expanded');

      var $form = $('form[action="/cart/add"]');
      var $btnSubmit = $form.find('.btn-submit');
      var $btnLimited = $form.find('.btn-limited');
      var $selectedOption = $('.swatch .swatch__element input:checked');
      var inventory = $selectedOption.data('quantity');

      $('.form__popup-error')
        .find('span.product-quantity')
        .text(inventory);
      $('.form__popup-error').addClass('popup-expanded');

      $selectedOption.data('available', false);

      $btnSubmit.addClass('hide');
      $btnLimited.removeClass('hide');

      setTimeout(function() {
        $('.form__popup-error').removeClass('popup-expanded');
      }, 5000);
    }
  });
};

function slider_products($slider, dots, arrows, slidesToShow) {
  if ($slider.length > 0) {
    let $slides = $slider.find('.slider__slides');
    let fade = true;

    if (dots == undefined) {
      dots = false;
    }

    if (arrows == undefined) {
      arrows = false;
    }

    if (slidesToShow == undefined) {
      slidesToShow = 1;
    }

    if (slidesToShow > 1) {
      fade = false;
    }

    $slides.slick({
      dots: dots,
      arrows: arrows,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      speed: 1000,
      centerMode: false,
      variableWidth: false,
      adaptiveHeight: false,
      fade: fade,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}

function swatchToggle($input) {
  var $form = $input.closest('form[action="/cart/add"]');
  var $btnSubmit = $form.find('.btn-submit');
  var $btnSoldOut = $form.find('.btn-sold-out');
  var $isAvailable = $form.find('.is_available');
  var elementIsAvailable = $input.data('available');
  var max = $input.data('max');

  $isAvailable.toggleClass('hide', elementIsAvailable);
  $btnSubmit.toggleClass('hide', !elementIsAvailable);
  $btnSoldOut.toggleClass('hide', elementIsAvailable);
}

function quantityUpdate($this) {
  let $quantity = $this.closest('.quantity-controls');
  let $plus = $quantity.find('.plus');
  let $input = $quantity.find('input.qty');
  let min = parseInt($input.attr('min'));
  let max = parseInt($input.attr('max'));
  let $label = $quantity.find('span.qty');
  let val = parseInt($input.val());
  let step = parseInt($this.data('step'));

  if (val + step <= min) {
    val = min;
  } else if (val + step >= max) {
    val = max;
  } else {
    val += step;
  }

  $input.val(val).change();
  $label.text(val);

  if (val == 0) {
    $this.closest('tr').slideUp();
  }

  if (val == max) {
    $plus.addClass('disabled');
  } else {
    $plus.removeClass('disabled');
  }
}